// extracted by mini-css-extract-plugin
export default {"svg":"FAQCollapsible-svg__dp_qa"};